import $ from 'jquery';
let page = 1;

$('.insights-load-more-js').on('click', function(e) {
    e.preventDefault();
    page++;

    //  change the button text to loading...
    $('.insights-load-more-js span').text('Loading...');

    $.get(`/wp-json/pei/v1/insights/?page=${page}`, function(html) {

        // scroll to the new content
        let $newContent = $('<div>').html(html).attr('data-page', page);
        $('.insights-container-js').append($newContent);

        // Scroll to the first element of the newly added content
        const scrollToElement = $(`.insights-container-js > div[data-page='${page}']:first`);
        
        $('html, body').animate({
            scrollTop: scrollToElement.offset().top,
        }, 1000, 'linear');

        // Switch the text back to load more
        $('.insights-load-more-js span').text('Load More');

        // If the new page has no content, hide the load more button
        if (!html.trim()) {
            $('.insights-load-more-js').hide();
            // add a message to the end of the content
            $('.insights-container-js').append('<h5 class="text-center">No more insights to load.</h5>');
        }

   
    });
});